import React, { PropsWithChildren, RefObject } from 'react'

import { Body1 } from '@ui/Typography/Typography'
import { TextColorType } from '@ui/design-system/colors/colors'

interface Props extends PropsWithChildren {
  color?: TextColorType
  medium?: true | undefined
  dangerouslySetInnerHTML?: { __html: string }
  ref?: RefObject<HTMLSpanElement | null>
}

export const ModalBodyText: React.FC<Props> = ({
  children,
  dangerouslySetInnerHTML,
  color,
  medium,
  ref,
}) => (
  <Body1
    medium={medium}
    dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    color={color ?? 'text-med-em'}
    ref={ref}
  >
    {children}
  </Body1>
)
